module.exports = __webpack_public_path__ + "img/gia-han-ho-so-icon.49de7ce3.svg";